namespace TabAurous.Master {
    export interface CustomerCategoryForm {
        Code: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        UpgradeValue: Serenity.DecimalEditor;
        NextLevel: Serenity.LookupEditor;
    }

    export class CustomerCategoryForm extends Serenity.PrefixedContext {
        static formKey = 'Master.CustomerCategory';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomerCategoryForm.init)  {
                CustomerCategoryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.LookupEditor;

                Q.initFormType(CustomerCategoryForm, [
                    'Code', w0,
                    'Name', w0,
                    'UpgradeValue', w1,
                    'NextLevel', w2
                ]);
            }
        }
    }
}
